import { HttpParams } from '@angular/common/http'
import { ChangeDetectorRef, Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { CellType, GridPanel } from '@grapecity/wijmo.grid'

import { BaseComponent, Grid, ListItem } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    templateUrl: './wip-report.component.html',
    styleUrls: ['./wip-report.component.css'],
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        GridExportComponent,
        WjInputModule,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class WipReportComponent extends BaseComponent {
    private cdr = inject(ChangeDetectorRef)
    faSpinner = faSpinner
    wipGrid: Grid<any>
    wipMonth: Date = new Date(new Date().setMonth(new Date().getMonth() - 2))

    pmList: ListItem<number>[] = []
    selectedPm?: number

    activeMap: ListItem<number>[] = [
        new ListItem(1, 'Active'),
        new ListItem(2, 'Soft Closed'),
        new ListItem(3, 'Hard Closed'),
        new ListItem(0, 'Pending'),
    ]

    constructor() {
        super()
        this.activeMap[0].$checked = true
        this.wipGrid = new Grid<any>(this.services, 'id', this)
            .wrapColumnHeaders(80)
            .isReadOnly(true)
            .editOnDoubleClick(false)
            .showAggregateRow(true)
        this.getParameters()
    }

    /**
     * Fetches and processes parameter values to populate the action toolbar options.
     */
    getParameters() {
        this.cancelableRequest(
            'parameters',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.get('/api/WipReport/GetParameters'),
                    this.services.data.get('/api/Projections/GetOpenMonth'),
                )
                .subscribe({
                    next: result => {
                        this.pmList = result[0].projectManagersById.map(x => new ListItem<number>(x.key, x.value))
                        this.wipMonth = result[1]
                        this.cdr.detectChanges()
                        setTimeout(() => {
                            this.initialLoadingComplete()
                            this.refresh()
                        }, 10)
                    },
                }),
        )
    }

    /**
     * Fetches the WIP report data based on the selected parameters in the action toolbar.
     */
    refresh() {
        if (this.isInitialLoading || this.selectedPm === undefined) return
        const params = new HttpParams()
            .set('wipMonth', this.wipMonth.toISOString())
            .set(
                'jobStatusString',
                this.activeMap
                    .filter(item => item.$checked)
                    .map(x => x.value)
                    .join(','),
            )
            .set('projectManager', this.selectedPm)

        this.cancelableRequest(
            'data',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/WipReport/GetWipReportData', params)).subscribe({
                next: result => {
                    this.wipGrid.items = result[0]
                },
            }),
        )
    }

    gridItemFormatter = (panel: GridPanel, r, c, cell: HTMLDivElement) => {
        if (panel.cellType === CellType.Cell) {
            const row = panel.grid.rows[r]
            const col = panel.grid.columns[c] as any
            const rowItem = row.dataItem

            cell.style.color = 'unset'
            if (rowItem[col.binding] < 0) {
                cell.style.color = 'red'
            }
        }
    }
}
